var permissions = []
var user = {}
if (localStorage.getItem('permissions')) {
  permissions = localStorage.getItem('permissions')
  user = JSON.parse(localStorage.getItem('user'))
}
var authRoute = [{
  type: 'tree',
  icon: 'fa fa-dashboard',
  name: 'Dashboard',
  router: {
    name: 'Dashboard'
  }
}]

// ============================ Master ==============================
var master = {
  type: 'tree',
  icon: 'fa fa-plus-square',
  name: 'Master',
  items: []
}
// ============================ LoanPlan ==============================
if (permissions.includes('menu-loan-plan')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Loan Plan',
    router: {
      name: 'loanplan'
    }
  })
}
if (permissions.includes('menu-collection-center')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Groups',
    router: {
      name: 'group'
    }
  })
}
if (permissions.includes('menu-state')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'State',
    router: {
      name: 'State'
    }
  })
}

if (permissions.includes('menu-bank')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Bank',
    router: {
      name: 'bank'
    }
  })
}
if (permissions.includes('menu-branch')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Branches',
    router: {
      name: 'branches'
    }
  })
}
if (permissions.includes('menu-staff-branches')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Staff Branch',
    router: {
      name: 'staffbranches'
    }
  })
}
if (permissions.includes('menu-branch-center')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Branch Center',
    router: {
      name: 'branchCenter'
    }
  })
}
if (permissions.includes('menu-leave')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Leave',
    router: {
      name: 'leave'
    }
  })
}
if (permissions.includes('menu-designation')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Designation',
    router: {
      name: 'designation'
    }
  })
}
if (permissions.includes('menu-miscellneous')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Miscellaneous',
    router: {
      name: 'mixed'
    }
  })
}
// ============================ Software Timing ==============================
if (permissions.includes('menu-software-timing')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Software Timing',
    router: {
      name: 'softwareTiming'
    }
  })
}
if (permissions.includes('menu-session')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Session',
    router: {
      name: 'sessionMaster'
    }
  })
}
if (permissions.includes('menu-setting')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Setting',
    router: {
      name: 'setting'
    }
  })
}
if (permissions.includes('menu-series')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Series',
    router: {
      name: 'series'
    }
  })
}
if (permissions.includes('menu-branch') || permissions.includes('menu-staff-branches') || permissions.includes('menu-collection-center') || permissions.includes('menu-state') || permissions.includes('menu-designation') || permissions.includes('menu-series') || permissions.includes('menu-leave') || permissions.includes('menu-bank') || permissions.includes('menu-relation') || permissions.includes('menu-reason') || permissions.includes('menu-identity-proof') || permissions.includes('menu-purpose') || permissions.includes('menu-loan-plan') || permissions.includes('menu-software-timing')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(master)
  }
}

// ============================ HRM ==============================
var hrm = {
  type: 'tree',
  icon: 'fa fa-id-card',
  name: 'HRM',
  items: []
}
if (permissions.includes('menu-employee')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee',
    router: {
      name: 'employee'
    }
  })
}
if (permissions.includes('menu-salary')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Salary',
    router: {
      name: 'salary'
    }
  })
}
if (permissions.includes('menu-holiday')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Holiday',
    router: {
      name: 'holiday'
    }
  })
}
if (permissions.includes('menu-employee-transfer')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee Transfer',
    router: {
      name: 'employeetransfer'
    }
  })
}
if (permissions.includes('menu-member-transfer')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Transfer',
    router: {
      name: 'employeemembertransfer'
    }
  })
}
if (permissions.includes('menu-update-center-leader')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Update Center Leader',
    router: {
      name: 'updatecenterleader'
    }
  })
}
if (permissions.includes('menu-print-letter')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Print Letter',
    router: {
      name: 'printemployeeletters'
    }
  })
}
if (permissions.includes('menu-employee-leave')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee Leave',
    router: {
      name: 'employeeleave'
    }
  })
}
if (permissions.includes('menu-attendance')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Attendance',
    router: {
      name: 'attendance'
    }
  })
}
/*
hrm.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Employee Salary Details',
  router: {
    name: 'employeesalarydetail'
  }
})
hrm.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Employee Absent Detail',
  router: {
    name: 'employeeabsentdetail'
  }
})
*/
if (permissions.includes('menu-holiday') || permissions.includes('menu-employee') || permissions.includes('menu-print-letter') || permissions.includes('menu-update-center-leader') || permissions.includes('menu-employee-transfer')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(hrm)
  }
}

// ============================ Area Survey ==============================
if (permissions.includes('menu-area-survey')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-map-marker',
    name: 'Area Survey',
    router: {
      name: 'areaSurvey'
    }
  })
}

// ============================ Member ==============================
var member = {
  type: 'tree',
  icon: 'fa fa-users',
  name: 'Members',
  items: []
}
if (permissions.includes('menu-member')) {
  member.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Members',
    router: {
      name: 'customer'
    }
  })
}
if (permissions.includes('menu-member-group')) {
  member.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Group',
    router: {
      name: 'customergroup'
    }
  })
}
if (permissions.includes('menu-member') || permissions.includes('menu-member-group')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(member)
  }
}

// ============================ Create Loan =========================
var createLoan = {
  type: 'tree',
  icon: 'fa fa-credit-card',
  name: 'Apply For Loan',
  items: []
}
if (permissions.includes('menu-download-loan-form')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Download Loan Form',
    router: {
      name: 'downloadloanform'
    }
  })
}
if (permissions.includes('menu-individual-loan')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Individual Loan',
    router: {
      name: 'individualLoan'
    }
  })
}
if (permissions.includes('menu-group-loan')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Group Loan',
    router: {
      name: 'groupLoan'
    }
  })
}
if (permissions.includes('menu-download-loan-form') || permissions.includes('menu-individual-loan') || permissions.includes('menu-group-loan')) {
  authRoute.push(createLoan)
}

// ============================ Disbursment List =========================
var disbursement = {
  type: 'tree',
  icon: 'fa fa-tasks',
  name: 'Disbursement',
  items: []
}
if (permissions.includes('menu-disbursement')) {
  disbursement.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Disbursed',
    router: {
      name: 'disbursment'
    }
  })
}
if (permissions.includes('menu-group-disbursement')) {
  disbursement.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Group Disbursed',
    router: {
      name: 'groupMemberDisbursment'
    }
  })
}
// if (permissions.includes('loan-disbursement-view-any')) {
//   disbursement.items.push({
//     type: 'item',
//     icon: 'fa fa-circle-o',
//     name: 'Group Disbursed',
//     router: {
//       name: 'groupDisbursment'
//     }
//   })
// }
if (permissions.includes('menu-disbursement') || permissions.includes('menu-group-disbursement')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(disbursement)
  }
}
// ============================ Loan ==============================
// if (permissions.includes('loan-disbursement-view-any')) {
//   authRoute.push({
//     type: 'item',
//     icon: 'fa fa-money',
//     name: 'Create/Disbursment Loan',
//     router: {
//       name: 'loan'
//     }
//   })
// }

// ============================ showCollection ==============================
if (permissions.includes('menu-loan-summery')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-leanpub',
    name: 'Loan Summary',
    router: {
      name: 'loanSummary'
    }
  })
}

// ============================ Collection ==============================
var paymentCollection = {
  type: 'tree',
  icon: 'fa fa-money',
  name: 'EMI Records',
  items: []
}
if (permissions.includes('menu-paid-emi')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Paid EMIs',
    router: {
      name: 'showCollection'
    }
  })
}
if (permissions.includes('menu-due-emi')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Due EMIs',
    router: {
      name: 'emiCollection'
    }
  })
}
if (permissions.includes('menu-promise-to-pay')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-thumbs-up',
    name: 'Promise To Pay',
    router: {
      name: 'promisetopay'
    }
  })
}
if (permissions.includes('menu-group-emi-collection')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Group EMI Collection',
    router: {
      name: 'groupEmiCollection'
    }
  })
}
if (permissions.includes('menu-member-collection')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Member Collection',
    router: {
      name: 'memberCollection'
    }
  })
}
if (permissions.includes('menu-paid-emi') || permissions.includes('menu-due-emi') || permissions.includes('menu-promise-to-pay') || permissions.includes('menu-group-emi-collection') || permissions.includes('menu-member-collection')) {
  authRoute.push(paymentCollection)
}

// ============================ Approvals ==============================
var approval = {
  type: 'tree',
  icon: 'fa fa-check-square-o',
  name: 'Approvals',
  items: []
}
if (permissions.includes('menu-salary-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Salary',
    router: {
      name: 'approvesalary'
    }
  })
}
if (permissions.includes('menu-collection-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Collection',
    router: {
      name: 'collection'
    }
  })
}
if (permissions.includes('menu-sattlement-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Settlement',
    router: {
      name: 'approveSettlement'
    }
  })
}
if (permissions.includes('menu-salary-approve') || permissions.includes('menu-collection-approve') || permissions.includes('menu-sattlement-approve')) {
  authRoute.push(approval)
}
// ============================ Entry ==============================
var entity = {
  type: 'tree',
  icon: 'fa fa-desktop',
  name: 'Settlements',
  items: []
}
if (permissions.includes('menu-sattlement')) {
  entity.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Settlement',
    router: {
      name: 'settlement'
    }
  })
}
if (permissions.includes('menu-death-member')) {
  entity.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Death Member List',
    router: {
      name: 'deathMember'
    }
  })
}
if (permissions.includes('menu-sattlement') || permissions.includes('menu-death-member')) {
  authRoute.push(entity)
}

// ============================ CIBIL API ==============================
if (permissions.includes('menu-cibil')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-black-tie',
    name: 'CIBIL',
    router: {
      name: 'cibil'
    }
  })
}

// ============================ ACCOUNTING ==============================
if (permissions.includes('menu-voucher')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'ACCOUNTING'
  })
}

// ============================ Voucher ==============================
var voucher = {
  type: 'tree',
  icon: 'fa fa-pencil-square-o',
  name: 'Voucher',
  items: []
}
if (permissions.includes('menu-day-book')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Day Book',
    router: {
      name: 'daybook'
    }
  })
}
if (permissions.includes('menu-voucher-entries')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Voucher Entries',
    router: {
      name: 'voucher'
    }
  })
}
if (permissions.includes('menu-payment')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Payment',
    router: {
      name: 'paymentvoucher'
    }
  })
}
if (permissions.includes('menu-receipt')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Receipt',
    router: {
      name: 'receiptvoucher'
    }
  })
}
if (permissions.includes('menu-contra')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Contra',
    router: {
      name: 'contravoucher'
    }
  })
}
if (permissions.includes('menu-journal')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Journal',
    router: {
      name: 'journalvoucher'
    }
  })
}
if (permissions.includes('menu-trial-balance')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Trial Balance',
    router: {
      name: 'trailbalance'
    }
  })
}
if (permissions.includes('menu-fy-trial-balance')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'FY Trial Balance',
    router: {
      name: 'FYTrialBalance'
    }
  })
}
if (permissions.includes('menu-fy-voucher-statement')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'FY Voucher Statement',
    router: {
      name: 'FYVoucherStatement'
    }
  })
}
if (permissions.includes('menu-fy-opening-balance')) {
  voucher.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'FY Opening Balance',
    router: {
      name: 'FYOpeningBalance'
    }
  })
}
if (permissions.includes('menu-voucher')) {
  authRoute.push(voucher)
}

// ============================ Portfolio ==============================
// if (permissions.includes('menu-portfolio')) {
//   authRoute.push({
//     type: 'item',
//     icon: 'fa fa-address-book',
//     name: 'Portfolio',
//     router: {
//       name: 'portfolio'
//     }
//   })
// }

// ============================ ACGroup ==============================
if (permissions.includes('menu-groups')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-address-book',
    name: 'ACGroup',
    router: {
      name: 'acgroup'
    }
  })
}

// ============================= Profit-Loss ==========================
if (permissions.includes('menu-profit-loss')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-money',
    name: 'Profit-Loss',
    router: {
      name: 'profitloss'
    }
  })
}
// ============================ Ledger ==============================
if (permissions.includes('menu-ledger')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-book',
    name: 'Ledger',
    router: {
      name: 'ledger'
    }
  })
}
// ============================ Branch Ledger ==============================
if (permissions.includes('menu-branch-ledger')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-book',
    name: 'Branch Ledger',
    router: {
      name: 'branchLedger'
    }
  })
}

// ============================ REPORTING HEADER ==============================
if (permissions.includes('menu-collection-report')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'REPORTING'
  })
}
// ============================ Reporting ================================
var reporting = {
  type: 'tree',
  icon: 'fa fa-file',
  name: 'Reporting',
  items: []
}
if (permissions.includes('menu-loan-summery')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Loan Report',
    router: {
      name: 'LoanReport'
    }
  })
}
if (permissions.includes('menu-due-emi-report')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Due EMI Reporting',
    router: {
      name: 'DueEmiReport'
    }
  })
}
if (permissions.includes('menu-collection-report')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Collection Reporting',
    router: {
      name: 'CollectionReport'
    }
  })
}
if (permissions.includes('menu-disbursement-report')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Disbursement Reporting',
    router: {
      name: 'DisbursementReport'
    }
  })
}
if (permissions.includes('menu-disbursement-report')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Settlement Reporting',
    router: {
      name: 'SettlementReport'
    }
  })
}
if (permissions.includes('menu-member-report')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Attendance',
    router: {
      name: 'memberemipaymentattendance'
    }
  })
}
if (permissions.includes('menu-online-payment')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Online Payment Reporting',
    router: {
      name: 'OnlinePaymentReport'
    }
  })
}
if (permissions.includes('menu-due-emi-report') || permissions.includes('menu-collection-report') || permissions.includes('menu-disbursement-report') || permissions.includes('menu-member-report') || permissions.includes('menu-online-payment')) {
  authRoute.push(reporting)
}
// ============================ PERMISSION ==============================
if (permissions.includes('role-permission-view-any')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'PERMISSION'
  })
}

// ============================ Role & Permission ==============================
var rolePermission = {
  type: 'tree',
  icon: 'fa fa-desktop',
  name: 'Role & Permission',
  items: []
}
if (permissions.includes('role-permission-view-any')) {
  rolePermission.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Permission',
    router: {
      name: 'permission'
    }
  })
}
if (permissions.includes('menu-role')) {
  rolePermission.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Role',
    router: {
      name: 'role'
    }
  })
}
if (permissions.includes('menu-role') || permissions.includes('role-permission-view-any')) {
  authRoute.push(rolePermission)
}

module.exports = authRoute



// WEBPACK FOOTER //
// ./src/lib/slideMenuItems.js